import axios from "axios";
import { convertSortDir } from "../utils";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getEmployees = async (q, filter_params, page, page_size, sort_by, sort_dir) => {

    let params = filter_params
    params['page'] = page
    params['page_size'] = page_size
    params['q'] = q
    params['sort_by'] = sort_by
    params['sort_dir'] = convertSortDir(sort_dir)

    const res = await axios.get(BACKEND_URL+'/employees', {
        params,
        withCredentials: true
    });
    return res;
}

export const createEmployee = async (createObj) => {
    createObj  = Object.fromEntries(Object.entries(createObj).filter(([_, v]) => v !== undefined));
    const res = await axios.post(BACKEND_URL+'/employees',
    createObj,
    {
        withCredentials: true,
        successMessage: "Employee ได้ถูกสร้างแล้ว"
    });
    return res;
}

export const updateEmployee = async (id, updateObj) => {
    const res = await axios.put(BACKEND_URL+`/employees/${id}`,
    updateObj,
    {
        withCredentials: true,
        successMessage: "Employee ได้ถูกแก้ไขแล้ว"
    });
    return res;
}

export const deleteEmployee = async (id) => {
    const res = await axios.delete(BACKEND_URL+`/employees/${id}`,
    {
        withCredentials: true,
        successMessage: "Employee ได้ถูก Deactivate แล้ว"
    });
    return res;
}

export const restoreEmployee = async (id) => {
    const res = await axios.post(BACKEND_URL+`/employees/${id}/restore`,
    {},
    {
        withCredentials: true,
        successMessage: "Employee ได้ถูก Activate แล้ว"
    });
    return res;
}